import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import EmbeddedChatAgents from './pages/EmbeddedChatAgents';

function App(){
  return ( <Router>
    <Routes>
      <Route path="/" element={<EmbeddedChatAgents />} />
    </Routes>
  </Router> )
}
export default App;